import { useState } from 'react';
import { BookingService, CreateBookingRequest, CreateBookingResponse } from '../services/BookingService';

export const useBooking = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createBooking = async (bookingData: CreateBookingRequest): Promise<CreateBookingResponse | null> => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await BookingService.createBooking(bookingData);
      return response;
    } catch (err: any) {
      setError(err.message || 'Failed to create booking');
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createBooking,
    isLoading,
    error,
    clearError: () => setError(null)
  };
};